import {
  Box,
  Button,
  Card,
  CardContent,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppStateType } from "../../../../redux/reducers";
import {
  createA11y,
  deleteA11y,
  fetchA11yes,
  partialUpdateA11y,
} from "../../../../redux/actions/a11yesActions";
import styled from "styled-components/macro";
import { FeedBackInfoMap, ModalController } from ".";
import { UnitStandardContext } from "../QuestionTabs";
import { useTranslation } from "react-i18next";

import { Close as CloseIcon } from "@material-ui/icons";
import { AppDispatchType } from "../../../../redux/store";
import {checkDependsCondition} from "../../../../utils/functions";
export const GradientWrapper = styled.div`
  box-shadow: 0px 0px 16.9299px rgba(53, 64, 82, 0.05);
  border-radius: 4.83711px;
  width: 72px;
  height: 15px;
  background-color: rgba(131, 243, 174, 0.1);
  display: flex;
  align-items: center;
  text-align: center;
  padding: 4px 8px;
  margin-bottom: 10px;
`;
export const GradientText = styled.div`
  background: linear-gradient(90deg, #84fab0 0%, #8feafe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 9px;
  text-transform: uppercase;
`;

const QTitle = styled(Box)`
    ${(props) => props.theme.breakpoints.down("sm")} {
      font-size: 14px;
    }
`

const YesNoContainer = withStyles((theme) => ({
  root: {
    borderRadius: "50%",
    position: "absolute",
    top: "50%",
    transform: "translate(-50%,-50%)",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeOut,
    }),
    placeItems: "center",
    background: "#303C57",
    cursor: "pointer",
  },
}))(Box);

const UnselectedButton = withStyles({
  root: {
    borderRadius: "50%",
    width: 30,
    minWidth: 30,
    height: 30,
    //color: "#727783",
    color: "#929AA9",
  },
})(Button);

type SwitchControlType = {
  attribute: any;
  itemKey: any;
  unitId: any;
};
function YesNoInput({
  onChange,
  value,
  a11y,
}: {
  onChange: (val: boolean | "reset") => void;
  value: boolean;
  a11y: any;
}) {
  const [noButtonRef, setNoButtonRef] = useState<any>(null!);
  const [yesButtonRef, setYesButtonRef] = useState<any>(null!);
  const { t } = useTranslation();

  const selectedRefference = value === true ? noButtonRef : yesButtonRef;
  return (
    <div
      style={{
        backgroundColor: "rgb(30, 41, 58)",
        borderRadius: "30px",
        padding: "3px 4px",
        position: "relative",
        minWidth: "70px",
      }}
    >
      <UnselectedButton
        ref={setNoButtonRef as any}
        color="primary"
        onClick={() => onChange(true)}
      >
        {t("generalWords_No")}
      </UnselectedButton>
      <UnselectedButton
        ref={setYesButtonRef as any}
        color="primary"
        onClick={() => onChange(false)}
      >
        {t("generalWords_Yes")}
      </UnselectedButton>
      <YesNoContainer
        style={{
          height: selectedRefference ? selectedRefference.clientHeight : "100%",
          width: selectedRefference ? selectedRefference.clientWidth : "30px",
          left:
            value === false && noButtonRef
              ? `${20 + noButtonRef.clientWidth}px`
              : "20px",
          display: a11y.id ? "grid" : "none",
        }}
      >
        {value === true ? t("generalWords_No") : t("generalWords_Yes")}
      </YesNoContainer>
    </div>
  );
}

export default function SwitchControl({
  attribute,
  itemKey,
  unitId,
}: SwitchControlType) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const unitStandard = useContext(UnitStandardContext);
  const user: any = useSelector(
    (state: AppStateType) => state.authReducer.user
  );
  const a11yes: any = useSelector(
    (state: AppStateType) => state.a11yesReducer.a11yes
  );
  const [a11y, setA11y] = useState<any>({});
  const [value, setValue] = useState(false);

  const onFetchA11y = async () => {
    await dispatch(fetchA11yes(unitId, user.token));
  };
  const onCreateA11y = async (a11yData: any) => {
    await dispatch(createA11y(a11yData, user.token));
  };
  const onDeleteA11y = async () => {
    const a11yIndex = a11yes.findIndex(
      (item: any) => item.attribute === a11y.attribute
    );
    await dispatch(deleteA11y(a11y.id, user.token, a11yIndex));
    setA11y({});
  };

  const onUpdateA11y = async (
    a11yIndex: any,
    a11yId: any,
    a11yData: any,
    userToken: any
  ) => {
    await dispatch(partialUpdateA11y(a11yIndex, a11yId, a11yData, userToken));
  };

  const onChange = async (is_absent: boolean | "reset") => {
    if (is_absent === "reset") {
      if (a11y.id) {
        await onDeleteA11y();
      }
      return;
    }
    if (a11y.id) {
      const a11yIndex = a11yes.findIndex(
        (item: any) => item.attribute === a11y.attribute
      );
      const a11yData = {
        is_absent,
      };
      setValue(is_absent);
      await onUpdateA11y(a11yIndex, a11y.id, a11yData, user.token);
    } else {
      const a11yData = {
        item: itemKey,
        attribute: attribute.key,
        accessibility_unit: unitId,
        is_absent,
      };
      await onCreateA11y(a11yData);
    }
    await onFetchA11y();
  };
  useEffect(() => {
    const currentA11y = a11yes.find(
      (a11y: any) => a11y.attribute === attribute.key && a11y.item === itemKey
    );
    if (currentA11y) {
      setValue(currentA11y.is_absent);
      setA11y(currentA11y);
    } else {
      setValue(false);
      setA11y({});
    }
    return () => {
      setA11y({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [a11yes]);
  const currentFeedback = FeedBackInfoMap.find((el) => {
    if (!el.attribute) {
      return el.key === attribute.key && el.unit_key === unitStandard.key;
    }
    return (
      el.key === attribute.key &&
      el.unit_key === unitStandard.key &&
      el.attribute &&
      a11y &&
      a11y.attribute === el.attribute
    );
  });
  const feedbackMap = {
    q_title: attribute.q_title,
    img: currentFeedback ? currentFeedback.img : "",
  };

  return (
    <>
      {checkDependsCondition(a11yes, attribute.depends_on) ? (
        <Box mt={3}>
          <Card>
            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography variant="h6">
                  {attribute.is_mandatory === true ? (
                    <GradientWrapper>
                      <GradientText>{t("CLP_UnitMandatoryLabel")}</GradientText>
                    </GradientWrapper>
                  ) : null}
                  {/* {attribute.q_title}
                                <HelpIcon style={{ marginLeft: "5px", height: "min-content" }} /> */}
                  <Box
                    style={{
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        display: "grid",
                        alignItems: "center",
                      }}
                    >
                      <QTitle>{attribute.q_title}</QTitle>
                      {/* {attribute.key} |||
                                        {a11y && a11y.attribute} */}
                      {/* {console.log(a11y)} */}
                    </div>

                    {/* Uncomment this to add commentaries */}
                    <ModalController
                      showButton={!!currentFeedback}
                      feedbackMap={feedbackMap}
                    />
                  </Box>
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "10px",
                  }}
                >
                  {a11y.id ? (
                    <>
                      <Tooltip title="Delete your answer">
                        <UnselectedButton
                          color="primary"
                          onClick={() => onChange("reset")}
                        >
                          <CloseIcon fontSize="inherit" />
                        </UnselectedButton>
                      </Tooltip>
                    </>
                  ) : null}
                  <YesNoInput onChange={onChange} value={value} a11y={a11y} />
                </div>
              </Box>
            </CardContent>
          </Card>
        </Box>
      ) : null}
    </>
  );
}
